<template>
    <div class="h-screen grid items-center justify-center">
        <FlowerIcon name="flower" class="w-12 h-12 animate-spin mx-auto" />
    </div>
</template>

<script>
import FlowerIcon from "./FlowerIcon.vue";

export default {
    name: "AppLoading",
    components: {
        FlowerIcon,
    },
}
</script>